import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/feedback.svg
 */
const IconFeedback: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M5.999 23.1A1.2 1.2 0 014.8 21.9v-3.6H3.6A3.6 3.6 0 010 14.7V5.1a3.6 3.6 0 013.6-3.6h16.8A3.598 3.598 0 0124 5.1v9.6a3.6 3.6 0 01-3.6 3.6h-9.844l-3.601 4.37a1.202 1.202 0 01-.956.43zm-2.4-19.206a1.202 1.202 0 00-1.2 1.199v9.602a1.2 1.2 0 001.2 1.199H6a1.202 1.202 0 011.2 1.2v1.489l1.873-2.26a1.194 1.194 0 01.923-.433h10.406a1.2 1.2 0 001.198-1.199V5.09a1.2 1.2 0 00-1.198-1.2l-16.802.004z"
      fill="currentColor"
    />
    <path
      d="M5.999 11.1a1.2 1.2 0 010-2.4h2.4a1.199 1.199 0 010 2.4H6zM17.997 11.1h-2.4a1.2 1.2 0 010-2.4h2.4a1.2 1.2 0 010 2.4z"
      fill="currentColor"
    />
  </svg>
);

export default IconFeedback;
